import type { LiteralUnion } from 'type-fest'
import { cookieRef } from '@layouts/stores/config'

export const resolveVuetifyTheme = (defaultTheme: LiteralUnion<'light' | 'dark' | 'system', string>): 'light' | 'dark' => {
  // Темная тема отключена - всегда возвращаем светлую тему
  return 'light'
}
